
<template>
    <div class="row" style="margin-left: 0px; margin-right: 0px;">
            <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <div class="row" style="margin-left: 0px; margin-right: 0px;">
                        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <h5 class="colorText">Titre</h5>
                        </div>
                        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <input type="text" class="form-control" placeholder="Titre" name='title' aria-describedby="basic-addon3" v-model="title">
                        </div>
                    </div>
                </div>
                <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <div class="row" style="margin-left: 0px; margin-right: 0px;">
                        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <h5 class="colorText">Langue</h5>
                        </div>
                        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                            <div class="form-group">
                                <select name='langue' class="form-control" v-model="langue">
                                    <option disabled value="">Choose</option>
                                    <option>fr</option>
                                    <option>en</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

            <div class="input-group green_line" v-for= "q1 in formulaire.next" :key="q1.id" >
                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                </div>

                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                        <input type="text" class="form-control" placeholder="Question" aria-describedby="basic-addon3" v-model="q1.intitule">
                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(formulaire,q1)" :title="trans.get('common.delete')">
                            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                        </button>
                    </div>

                    <div  class="input-group thin_green_line" v-for= "r1 in q1.next" :key="r1.id">

                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                            <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                        </div>

                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">

                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">    
                                <input type="text" class="form-control" placeholder="Réponse" aria-describedby="basic-addon3" v-model="r1.intitule"> 
                                <input v-show="r1.next.length==0" type="number" class="form-control" placeholder="Coeff PV-Ready"  aria-describedby="basic-addon3" v-model="r1.valeur">
                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(q1,r1)" :title="trans.get('common.delete')">
                                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                </button>
                            </div>
                            
                            <div class="input-group" v-for= "q2 in r1.next" :key="q2.id">

                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                </div>

                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;"> 
                                        <input type="text" class="form-control" placeholder="Question" aria-describedby="basic-addon3" v-model="q2.intitule">
                                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(r1,q2)" :title="trans.get('common.delete')">
                                            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                        </button>
                                    </div>

                                    <div class="input-group" v-for= "r2 in q2.next" :key="r2.id">
                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                            <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                        </div>

                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">    
                                                <input type="text" class="form-control" placeholder="Réponse" aria-describedby="basic-addon3" v-model="r2.intitule">
                                                <input v-show="r2.next.length==0" type="number" class="form-control" placeholder="Coeff PV-Ready" aria-describedby="basic-addon3" v-model="r2.valeur">
                                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(q2,r2)" :title="trans.get('common.remove')">
                                                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                </button>
                                            </div>

                                            <div class="input-group" v-for= "q3 in r2.next" :key="q3.id">

                                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                </div>

                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;"> 
                                                        <input type="text" class="form-control" placeholder="Question" aria-describedby="basic-addon3" v-model="q3.intitule">
                                                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(r2,q3)" :title="trans.get('common.remove')">
                                                            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                        </button>
                                                    </div>

                                                    <div class="input-group" v-for= "r3 in q3.next" :key="r3.id">
                                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                            <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                        </div>

                                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">    
                                                                <input type="text" class="form-control" placeholder="Réponse"  aria-describedby="basic-addon3" v-model="r3.intitule">
                                                                <input v-show="r3.next.length==0" type="number" class="form-control" placeholder="Coeff PV-Ready" aria-describedby="basic-addon3" v-model="r3.valeur">
                                                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(q3,r3)" :title="trans.get('common.remove')">
                                                                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                                </button>
                                                            </div>  




                                                            <div class="input-group" v-for= "q4 in r3.next" :key="q4.id">

                                                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                                    <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                                </div>

                                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;"> 
                                                                        <input type="text" class="form-control" :name='q1.id+"_"+r1.id+"_"+q2.id+"_"+r2.id+"_"+q3.id+"_"+r3.id+"_"+q4.id' placeholder="Question" aria-describedby="basic-addon3" v-model="q4.intitule">
                                                                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(r3,q4)" :title="trans.get('common.remove')">
                                                                            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                                        </button>
                                                                    </div>

                                                                    <div class="input-group" v-for= "r4 in q4.next" :key="r4.id">
                                                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                                            <span class="glyphicon glyphicon-arrow-right" id="basic-addon3" ></span>
                                                                        </div>

                                                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">    
                                                                                <input type="text" class="form-control" placeholder="Réponse" aria-describedby="basic-addon3" v-model="r4.intitule">
                                                                                <input v-show="r4.next.length==0" type="number" class="form-control"  placeholder="Coeff PV-Ready" aria-describedby="basic-addon3" v-model="r4.valeur">
                                                                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click="remove(q4,r4)" :title="trans.get('common.remove')">
                                                                                    <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                                                                                </button>
                                                                            </div>  
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mx-0">
                                                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                                                
                                                                        </div>

                                                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                            <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(q4,"Reponse")' :title="trans.get('common.add')">
                                                                                <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                                                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                                                </div>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mx-0">
                                                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                        
                                                                </div>

                                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                                    <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(r3,"Question")' :title="trans.get('common.add')">
                                                                        <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                                            <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mx-0">
                                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                        
                                                        </div>

                                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                            <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(q3,"Reponse")' :title="trans.get('common.add')">
                                                                <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mx-0">
                                                <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                                </div>
                                                <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                                    <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(r2,"Question")' :title="trans.get('common.add')">
                                                        <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                            <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mx-0">
                                        <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                        </div>
                                        <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                            <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(q2,"Reponse")' :title="trans.get('common.add')">
                                                <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="row mx-0">
                             <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                                    
                            </div>
                            

                            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(r1,"Question")' :title="trans.get('common.add')">
                                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                        <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                    </div>
                                </button>
                            </div>
                            </div>



                        </div>
                    </div>
                    <div class="row mx-0">
                     <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    
                    </div>

                    <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">               
                        <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(q1,"Reponse")' :title="trans.get('common.add')">
                            <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                                <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                            </div>
                        </button>
                    </div>
                    </div>
                </div>
            </div>
            <div class="col-md-1 ml-sm-0 col-lg-1 pt-1 px-1" >
                    
            </div>

            <div class="col-md-11 ml-sm-0 col-lg-11 pt-1 px-1">
                <button type="button" class="buttonOriginal" aria-label="Left Align" v-on:click='add(formulaire,"Question")'  :title="trans.get('common.add')">
                    <div class="row form-inline mb-3" style="margin-left: 0px; margin-right: 0px;">
                            <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                    </div>
                </button>
            </div>
        <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
                <input name="formulaire" type="hidden" id="formulaire" style="visibility:hidden" >
                <button type="button" class="buttonOriginal" v-on:click='save()'  :title="trans.get('common.save')">
                    <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                </button>
        </div>
    </div>
</template>

<script >

    export default {
        props : ['language'],     
        data : function(){
            return {
                formulaire:{
                    next :[ {
                        id :0,
                        type:"Question",
                        intitule : "",
                        next : [{
                            id: 1,
                            intitule :"Reponse",
                            type:"Reponse",
                            next:[],
                            valeur:1,
                            selection:"",
                        }],
                        selection:"",
                    }],
                },
                id:2,
                title:"",
                lang:'',
                langue:"",
            };
        },
        mounted: function(){
            this.lang=this.language;
        },
        methods :{
            add(n,typeP){
                if(typeP =="Question"){
                    var reponse = {
                        id: this.id,
                        intitule :typeP,
                        type: typeP,
                        next : [{
                            id: this.id++,
                            intitule :"Reponse",
                            type:"Reponse",
                            next:[],
                            valeur:1,
                            selection:"",
                        }],
                        valeur:1,
                        selection:"",
                    }
                    this.id++;
                }else{
                    var reponse = {
                        id: this.id,
                        intitule :typeP,
                        type: typeP,
                        next : [],
                        valeur:1,
                        selection:"",
                    }
                }

                n.next.push(reponse);
                this.id++;                
            },
            remove(parent,n){
                
                for ( var i = 0; i<parent.next.length;i++){
                    if(parent.next[i].id == n.id){
                        parent.next.splice(i,1);
                    }
                }
            },
            addQuestion(p){
               var question = {
                   id : this.id,
                   intitule: 'Question',
                   type: 'Question',
                   next:[],
                   selection:"",
               }    

                p.next.push(question);
                this.id++;   
            },
            
            save(){
                var data = JSON.stringify(this.formulaire);
                document.getElementById("formulaire").value=data;
                document.getElementById("saveQuestion").submit();
                
            },
            
                               
            
        },
    }

</script>
